export default {
  // 押金说明
  deposit_explain: '1、押金在第一次开水杯模式的时候一起支付\n2、押金在水杯模式年限满N年后退还。\n3、押金通过微信自动转账退回'
}
